import InfoAtendimento from './InfoAtendimento'

export default {
	components: { InfoAtendimento },
	props: {
		atendimento: null,
	},
	emits: ['clickCancelAtendimento', 'clickEditarAtendimento'],
	data() {},
	methods: {
		onClickCloseModal() {
			this.$emit('clickCancelAtendimento')
			this.closeModal()
		},
		onClickEditarAtendimento(idAtendimento) {
			this.$emit('clickEditarAtendimento', idAtendimento)
			/* this.closeModal() */
		},

		closeModal() {
			modal_padrao_vue.closeModal('modal_info_gerencial_sai')
		},
	},
	computed: {
		atendimentosModalView() {
			return this.atendimento?.atendimentos?.map((item) => {
				return {
					id: item.id,
					data_atendimento: item.data_atendimento,
					titulo_atendimento: item.titulo_atendimento,
					descricao_atendimento: item.descricao_atendimento,
					data_criacao: item.data_criacao,
				}
			})
		},
	},
	watch: {
		atendimento() {
			/* console.log(this.atendimento) */
		},
	},

	template: html`
		<section
			class="modal--content rounded-md  flex-1 w-auto !overflow-[initial] relative "
			data-id="modal_info_gerencial_sai"
			id="modal_info_gerencial_sai">
			<header
				class="flex items-center justify-between w-full px-24 pt-24 pb-16 bg-primary-pure ">
				<h2 class="text-lg font-medium text-white">Atendimento sequóia</h2>
				<button
					type="button"
					class="w-32 h-32 transition-transform rounded-full cursor-pointer hover:scale-125 bg-white/10 close-btn"
					data-xclose="modal_padrao"
					@click="onClickCloseModal">
					<svg class="w-32 h-32">
						<use xlink:href="#icon_close"></use>
					</svg>
				</button>
			</header>
			<div class="w-full !h-[32rem]  !bg-[#FAFAFB]">
				<div
					v-if="atendimento && atendimento?.atendimentos.length <=0"
					class="flex flex-col items-center justify-center w-full h-full gap-y-40 max-h-full pt-72">
					<q-icon name="search_off" size="6rem" class="text-neutral-100" />
					<p class="text-title-2 text-neutral-70">
						Nenhum atendimento sequóia encontrado.
					</p>
				</div>
				<div
					v-else
					class="p-16 flex flex-col gap-16 flex-1 overflow-y-auto !bg-[#FAFAFB] max-h-[38rem] 2xl:max-h-[33rem] ">
					<info-atendimento
						v-for="(atendimento,index) of atendimentosModalView"
						:atendimento="atendimento"
						:key="index"
						@click-editar-atendimento="onClickEditarAtendimento">
					</info-atendimento>
				</div>
			</div>
		</section>
	`,
}
